import type { SupernaturalEffect } from './types';

const registry = new Map<string, SupernaturalEffect>();

export function registerEffect(effect: SupernaturalEffect): void {
  registry.set(effect.id, effect);
}

export function getEffect(id: string): SupernaturalEffect | null {
  return registry.get(id) ?? null;
}

export function getAllEffects(): SupernaturalEffect[] {
  return Array.from(registry.values());
}

export function getEffectsByCategory(category: SupernaturalEffect['category']): SupernaturalEffect[] {
  return getAllEffects().filter((e) => e.category === category);
}

/* ── エフェクト永続化ストア ──
 * モジュールレベルで発動済みエフェクトを記録する。
 * Reactのリマウントが起きてもこのストアは保持されるため、
 * エフェクトコンポーネントは再マウント時にアニメーションをスキップして
 * 最終状態から開始できる。
 */
const activatedEffects = new Set<string>();

/** エフェクトが発動完了したことを記録 */
export function markEffectActivated(key: string): void {
  activatedEffects.add(key);
}

/** エフェクトが発動済みかどうかを確認 */
export function isEffectActivated(key: string): boolean {
  return activatedEffects.has(key);
}

/** ストアをクリア（ノード切り替え時にLineDialogViewから呼ぶ） */
export function clearActivatedEffects(): void {
  activatedEffects.clear();
}
